import { CSSProperties } from 'react';

export const COLORS = {
  active: '#1E96FC',
  inactive: '#5D7083',
  indicatorBg: '#EBF5FF',
  border: '#EEF0F2',
  background: 'white'
} as const;

export const getContainerStyle = (fullWidth?: boolean): CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: 8,
  backgroundColor: COLORS.background,
  border: `1px solid ${COLORS.border}`,
  borderRadius: 120,
  width: fullWidth ? '100%' : 'fit-content',
  position: 'relative'
});

export const getIndicatorStyle = (
  left: number,
  width: number,
  height: number
): CSSProperties => ({
  position: 'absolute',
  backgroundColor: COLORS.indicatorBg,
  borderRadius: 120,
  boxShadow: '0px 2px 4px rgba(48, 54, 60, 0.16)',
  transition:
    'left 0.3s cubic-bezier(0.4, 0, 0.2, 1), width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  zIndex: 0,
  left,
  width,
  height,
  opacity: width > 0 ? 1 : 0
});

export const getTabStyle = (fullWidth?: boolean): CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '4px 12px',
  borderRadius: 120,
  cursor: 'pointer',
  position: 'relative',
  zIndex: 1,
  flex: fullWidth ? 1 : 'none'
});

export const getIconStyle = (isActive: boolean): CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: 6,
  color: isActive ? COLORS.active : COLORS.inactive,
  transition: 'color 0.25s ease-in-out'
});

export const getLabelStyle = (isActive: boolean): CSSProperties => ({
  fontFamily: 'Roboto, sans-serif',
  fontWeight: 600,
  fontSize: 13,
  lineHeight: '24px',
  color: isActive ? COLORS.active : COLORS.inactive,
  whiteSpace: 'nowrap',
  transition: 'color 0.25s ease-in-out'
});
